import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Homepage from './Components/Pages/Homepage';
import Header from './Components/Templates/Header';
import Footer from './Components/Organism/Footer/Footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import PrivacyPolicy from './Components/Pages/Extra/PrivacyPolicy';
import TermsCondition from './Components/Pages/Extra/TermsAndCondition';
import RefundAndRegister from './Components/Pages/Extra/RefundAndRegister';
import WebSiteHomePage from './Components/Webiste/Homepage';
import NewHomepage from './Components/Pages/NewHomepage';
import DownloadRedirect from './Components/Pages/DownloadRedirect';
import { trackEvent } from './app/Firebase'; // adjust path to match your structure

function AppLayout() {
  const { pathname } = useLocation();
  const path = pathname.toLowerCase();

  // Log a page_view event every time the route changes (Firebase auto-logs
  // only the very first load, not client-side route changes in an SPA).
  useEffect(() => {
    trackEvent('page_view', { page_path: pathname });
  }, [pathname]);

  const showHeaderFooter =
    !path.includes('/extra') &&
    !path.startsWith('/bollywood-studio') &&
    path !== '/' &&
    path !== '/download' &&
    !path.startsWith('/new-home');

  return (
    <>
      {showHeaderFooter && <Header />}
      <Routes>
        <Route path='/' element={<NewHomepage />} />
        <Route path="/home" element={<Homepage />} />
        <Route path="/bollywood-studio" element={<WebSiteHomePage />} />
        <Route path="/download" element={<DownloadRedirect />} />
        <Route path="/extra/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/extra/Terms-and-conditions" element={<TermsCondition />} />
        <Route path="/extra/refund-register" element={<RefundAndRegister />} />
      </Routes>
      {showHeaderFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <>
      <Router>
        <AppLayout />
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;